function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavigationChevronRightWhite = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 8.06 14.71"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "m.35.35 7 7-7 7",
  style: {
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }
}));
export default SvgNavigationChevronRightWhite;